/**
 * Agreements API Contracts — compliance read surface
 *
 * Read-side contract for "everything this person signed" (admin-only, paginated,
 * audit-logged on the backend). The list item deliberately EXCLUDES the
 * signature artifact and mechanism payload bytes — identity/index only. See
 * plan U6.
 */

import { z } from 'zod'
import {
  AgreementMechanismSchema,
  AgreementStatusSchema,
  AgreementSubjectTypeSchema,
  SignerRoleSchema
} from '../../schemas/entities/signed-agreement'

// ============================================
// Agreement list item (artifact-excluded)
// ============================================

export const SignedAgreementListItemSchema = z.object({
  /** Agreement publicId. */
  id: z.string(),
  /** publicId of the SignableRequirement this satisfies. */
  requirementId: z.string(),
  /** Friendly label of the requirement (denormalized for the admin list). */
  requirementLabel: z.string().nullable(),
  subjectType: AgreementSubjectTypeSchema,
  subjectPublicId: z.string(),
  signerRole: SignerRoleSchema,
  signerName: z.string().nullable(),
  signedAt: z.string().nullable(),
  mechanism: AgreementMechanismSchema,
  status: AgreementStatusSchema,
  createdAt: z.string()
})
export type SignedAgreementListItem = z.infer<typeof SignedAgreementListItemSchema>

export const ListAgreementsForSignerResponseSchema = z.object({
  data: z.array(SignedAgreementListItemSchema),
  meta: z.object({
    total: z.number(),
    limit: z.number(),
    offset: z.number()
  })
})
export type ListAgreementsForSignerResponse = z.infer<typeof ListAgreementsForSignerResponseSchema>
